import { RegisterMode, UserRepository } from "../domain/userRepository";
import { AuthRepository, Roles } from "../domain/auth";
import { UserDetail } from "../domain/user";

export interface EnrollConfig {
  id_token?: string; // cases like Ticketmaster when we need the idpIdToken
}

export interface UserUseCases {
  enroll: (config?: EnrollConfig) => Promise<void>;
  getUserDetail: () => Promise<UserDetail>;
  getUserSelfie: () => Promise<string>;
}

export const userUseCases = ({
  userRepository,
  authRepository,
}: {
  userRepository: UserRepository;
  authRepository: AuthRepository;
}): UserUseCases => ({
  enroll: async (config?: EnrollConfig) => {
    const auth = authRepository.get()!;
    const userData = flattenObjectArray(auth.claims?.map(claim => ({ [claim]: auth[claim] })) ?? []);

    if (config?.id_token) {
      userData.idToken = config.id_token;
    }
    const mode = auth.roles.includes(Roles.PostOnboardingsAuto) ? RegisterMode.Auto : RegisterMode.Assisted;
    await userRepository.enroll(userData, mode);
    authRepository.update({ enrolled: true });
  },
  getUserDetail: async () => {
    const auth = authRepository.get()!;

    return (await userRepository.getUserDetail(auth.userId)).data;
  },
  getUserSelfie: async () => {
    const auth = authRepository.get()!;

    return (await userRepository.getUserSelfie(auth.userId)).data;
  },
});

const flattenObjectArray = (array: object[]) => Object.assign({}, ...array);
